import { SITE } from '../config/site'
import { LegalLayout } from './LegalLayout'
import styles from './LegalPage.module.css'

export function RefundsPage() {
  return (
    <LegalLayout
      title="Refund Policy"
      lede="Gesturely includes a full-feature trial before purchase. This policy explains the limited circumstances in which a refund may be considered."
    >
      <section>
        <h2>Try Gesturely before purchasing</h2>
        <p>
          Gesturely includes a 14-day full-feature trial inside the app so you can
          evaluate the software before purchasing. The trial is available before
          payment and is not a Paddle trial or a money-back guarantee.
        </p>
      </section>

      <section>
        <h2>General refund position</h2>
        <p>
          Because Gesturely can be fully evaluated before purchase, purchases are
          generally final and non-refundable. We do not ordinarily provide refunds
          because you changed your mind, did not use the trial, or decided after
          purchase that you no longer need the app.
        </p>
      </section>

      <section>
        <h2>When a refund may be considered</h2>
        <p>We may consider a refund for:</p>
        <ul>
          <li>a duplicate purchase;</li>
          <li>a billing error; or</li>
          <li>
            a verified technical problem that substantially prevents Gesturely from
            functioning as described and cannot reasonably be resolved through support.
          </li>
        </ul>
        <p>
          A request should normally be made within 14 days of purchase and should
          include the purchase email, order information, and enough detail for us to
          understand the reason for the request. The 14-day request period is not a
          promise that a refund will be granted.
        </p>
      </section>

      <section>
        <h2>Paddle and applicable law</h2>
        <p>
          Purchases are processed by Paddle as Merchant of Record. Any approved refund
          is processed subject to Paddle’s procedures. You may be asked to work with
          Paddle or provide information needed to locate and review the transaction.
        </p>
        <p>
          Nothing in this policy limits any non-waivable refund, withdrawal, or other
          consumer rights available under applicable law. Where applicable law requires
          a different result, that law controls.
        </p>
      </section>

      <section>
        <h2>License after a refund</h2>
        <p>
          If a purchase is refunded, reversed, or charged back, the associated
          Gesturely license may be revoked and you must stop using copies activated
          under that license.
        </p>
      </section>

      <section>
        <h2>Requesting help or a refund</h2>
        <p>
          Before requesting a technical refund, contact us so we can try to resolve the
          problem. Send support and refund requests to{' '}
          <a href={`mailto:${SITE.supportEmail}`}>{SITE.supportEmail}</a>.
        </p>
        <address className={styles.address}>
          {SITE.legalName}
          <br />
          {SITE.legalAddress[0]}
          <br />
          {SITE.legalAddress[1]}
          <br />
          {SITE.legalAddress[2]}
        </address>
      </section>
    </LegalLayout>
  )
}
